import React from 'react';

const VehicleTabs = ({ vehicles, activeTab, onTabChange }) => {
  return (
    <div className="bg-white rounded-xl p-1 mb-6" data-testid="vehicle-tabs">
      <div className="flex">
        {vehicles.map((vehicle) => {
          const isActive = activeTab === vehicle.id;
          
          return (
            <button
              key={vehicle.id}
              onClick={() => onTabChange(vehicle.id)}
              data-testid={`vehicle-tab-${vehicle.id.toLowerCase()}`}
              className={`flex-1 py-3 px-4 text-sm font-medium rounded-lg transition-all duration-200 relative ${
                isActive
                  ? 'text-[#FF8C00] bg-[#FF8C00]/5'
                  : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }`}
            >
              {vehicle.tabLabel || vehicle.id}
              
              {/* Active lane indicator */}
              {isActive && (
                <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-12 h-0.5 bg-[#FF8C00] rounded-full transition-all duration-300" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default VehicleTabs;
